module.exports = __webpack_public_path__ + "img/84.e518a90e.png";